import axios from "axios";
import {Button} from "react-bootstrap";
import {saveAs} from "file-saver";
import {useState} from "react";
import {toCleanSnakeCase} from "../utils/stringManipulation";

type DownloaderProps = {
    id: number,
    type: "template" | 'internal' | string,
    filename?: string,
    version?: string,
    text?: string
}

export const Downloader = (props: DownloaderProps) => {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    let url = `${process.env.REACT_APP_SERVER_URL}`
    switch (props.type) {
        case "template":
            url += `/download_template_file`;
            break;
        case "internal":
            url += `/download_internal_document`;
            break;
        case "help":
            url += `/download_help_file`;
            break;
        default:
            url += `/download_${props.type}`;
            break;
    }

    const generateFilename = () : string | undefined => {
        if (!props.filename) { return undefined; }
        if (props.version) {
            const firstDotIndex = props.filename.lastIndexOf(".");
            const baseName = props.filename
                .substring(0, firstDotIndex)
                .replaceAll('.', '_');
            const extension = props.filename.substring(firstDotIndex + 1);
            return toCleanSnakeCase(`${baseName}_${props.version}.${extension}`)
        }
        return toCleanSnakeCase(props.filename);
    }

    const handleDownload = () => {
        setLoading(true);
        axios
            .get(
                `${url}/${props.id}`,
                {
                    method: "GET",
                    responseType: 'blob',
                }
            )
            .then((response) => {
                const {data, headers} = response;
                let filename = generateFilename();
                if (!filename) {
                    const contentDisposition = headers[`content-disposition`];
                    filename = 'fichier_télechargé'
                    if (contentDisposition) {
                        const match = contentDisposition.match(/filename="(.+)"/);
                        filename = match ? decodeURIComponent(match[1]) : filename;
                    }
                }
                saveAs(data, filename)
            })
            .catch(error => {
                setError(error?.response?.status || 'ERR')
            })
            .finally(
                () => setLoading(false)
            )
    }

    return (
        <Button
            onClick={handleDownload}
            disabled={loading || error !== ''}
        >
            {
                error
                    ? `Erreur [HTTP ${error}]`
                    : props.text || `Télécharger`
            }
        </Button>
    )
}